import { Typography } from '@components/common/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const LineBreak = styled.div<{ hide?: boolean }>`
  margin: 12px 0;
  width: 100%;
  height: 1px;
  opacity: 0.5;
  background-color: ${({ theme }) => theme.colors.primary.lighter};
  ${({ hide }) => hide && `opacity: 0`};
`;

export const TextAndCalculationContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DescriptionContainer = styled.div`
  width: calc(100% - 11rem);
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  max-width: 65%;
`;

export const DescriptionText = styled(Typography)<{ tooltipTitle?: boolean; bold?: boolean; lighterText?: boolean }>`
  display: block;
  color: ${({ theme }) => theme.colors.functional.white};
  font-family: ${({ theme }) => theme.fonts.archivo};
  ${({ tooltipTitle }) => tooltipTitle && `margin-bottom: 18px;`};
  ${({ bold }) => bold && `font-weight: 700;`};
  ${({ lighterText, theme }) => lighterText && `color: ${theme.colors.primary.lighter};`}
`;

export const AmountText = styled(DescriptionText)<{ bold?: boolean; position?: 'left' | 'right' }>`
  text-align: right;
  font-family: ${({ theme }) => theme.fonts.mono};
`;

export const CalculationBlock = styled.div`
  width: 8rem;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const OperatorContainer = styled.div<{ position: 'left' | 'right'; result?: boolean }>`
  width: 1.5rem;
  display: flex;
  & > span {
    ${({ position }) => (position === 'right' ? `margin-left: auto` : ``)};
  }
`;

export const Values = styled.div`
  width: 5rem;
  overflow: clip;
`;
